export const GAME = {
    title: 'YGTopu',
    worldWidth: 1600,
    worldHeight: 900,
    groundY: 800,
    goalHeight: 190,
    goalDepth: 125,
    maxPlayers: 5,
    roomCodeLength: 6,
    nicknameMaxLength: 16,
    simulationHz: 60,
    inputHz: 30,
    statePatchMs: 40,
    countdownMs: 3000,
    goalPauseMs: 2000,
    reconnectGraceSeconds: 20,
    shotCooldownMs: 320,
    emoteCooldownMs: 1500,
    campingLimitMs: 5000,
    campingFreezeMs: 1500,
    campingImmunityMs: 4000,
    airControlMultiplier: 0.65,
};
export const ROOM_CODE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
export const MATCH_PRESETS = [
    { id: '1v1', label: '1 v 1', bluePlayers: 1, redPlayers: 1 },
    { id: '1v2', label: '1 v 2', bluePlayers: 1, redPlayers: 2 },
    { id: '2v2', label: '2 v 2', bluePlayers: 2, redPlayers: 2 },
    { id: '2v3', label: '2 v 3', bluePlayers: 2, redPlayers: 3 },
];
export const MATCH_DEFAULTS = {
    presetId: '1v1',
    durationSeconds: 90,
    goalLimit: 0,
    goldenGoal: false,
    skillsEnabled: true,
    friendlyCollision: true,
    campingPenalty: true,
    threePlayerTeam: 'red',
};
export const TEAM = {
    blue: { label: 'Mavi', color: 0x4d9eff, hex: '#4d9eff' },
    red: { label: 'Kırmızı', color: 0xff5c70, hex: '#ff5c70' },
};
